import React from 'react';
import style from '../css/Card_two.module.css';

function Card_two() {
	const images = [
		'https://www.ahstatic.com/photos/6790_ho_00_p_1024x768.jpg',
		'https://media.istockphoto.com/id/912322946/photo/convenient-way-of-payment.jpg?s=612x612&w=0&k=20&c=dLiM1LqGllJs6aOZInNwObJcvqxjz1nJk7nw6me2JW0=',
		'https://blogimage.vantagecircle.com/content/images/2024/01/13-Corporate-Reward-Programs-with-Essentials--Benefits--Ideas--and-Steps.png',
	];

	const benefits = [
		{
			title: 'More options, more deals',
			desc: 'Exporest provides your team with special rates among a massive travel inventory featuring top suppliers.',
		},
		{
			title: 'Spend guardrails',
			desc: 'Custom policies let your employees book and spend as needed while protecting the company budget.',
		},
		{
			title: 'Exporest Rewards',
			desc: 'Reward employees when they book travel below budget — at no cost to you.',
		},
	];

	return (
		<div className={style.container}>
			<div className={style.header}>
				<h2>Sky-high company savings</h2>
				<p>
					Intelligent corporate travel management that can drive real savings
				</p>
			</div>

			<div className={style.cardGrid}>
				{images.map((image, i) => (
					<div key={i} className={style.cardColumn}>
						<div className={style.card}>
							<img
								src={image}
								alt={`Image ${i + 1}`}
								className={style.cardImage}
							/>
						</div>
						<div className={style.benefitItem}>
							<h1>{i + 1}</h1>
							<div>
								<h4>{benefits[i].title}</h4>
								<p>{benefits[i].desc}</p>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default Card_two;
